import "../../App.css";
import Sidebar from "../Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useEffect, useState } from "react";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";

function CargaMasiva(props) {
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [file, setFile] = useState(null);
  const [uploadTypes, setUploadTypes] = useState([]);
  const [selectedType, setSelectedType] = useState(null);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!selectedType) {
      alert("Debe seleccionar un tipo de carga");
      return null;
    }
    if (!file) {
      alert("Debe seleccionar un archivo");
      return null;
    }

    const formData = new FormData();
    formData.append("fileobject", file);

    let response = await fetch(
      `${Parametros.urlApi}upload_carga?tipo_carga=${selectedType}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + usuario.key,
        },
        body: formData,
      }
    );

    if (response.ok) {
      alert("Archivo cargado correctamente");
    } else {
      const data = await response.json();
      alert(data.detail || "Error al cargar archivo");
    }

    setFile(null);
    document.getElementById("files").value = "";
  };
  const handleSetFile = (e) => {
    setFile(e.target.files[0]);
  };

  useEffect(() => {
    fetch(Parametros.urlApi + `upload_types`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        setUploadTypes(res);
      });
  }, [usuario.key]);

  const downloadArchive = () => {
    if (!selectedType) {
      alert("Debe seleccionar un tipo de carga");
      return null;
    }
    fetch(Parametros.urlApi + `upload_type_archive/${selectedType}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.blob())
      .then((blob) => {
        var file = window.URL.createObjectURL(blob);
        window.location.assign(file);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="App">
      <div>
        <Sidebar tipo="1"></Sidebar>
      </div>

      <UserTab nombre={"Carga Masiva"}></UserTab>
      <br></br>
      <br></br>
      <br></br>
      <div className="container">
        <div>
          <div className="col-md-12">
            <div style={{ margin: "0 auto", maxWidth: 480 }}>
              <select
                onChange={(e) => setSelectedType(e.target.value)}
                style={{
                  width: "100%",
                  height: 36,
                  textAlign: "center",
                  marginBottom: 20,
                }}
              >
                <option value="">--- Seleccionar tipo de carga ---</option>
                {uploadTypes.map((item) => {
                  return (
                    <option key={item.upload_type_id} value={item.name}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
              <br />
              <button
                className="form-control button brEdit btn-primary"
                onClick={downloadArchive}
              >
                Descargar Documento
              </button>
              <input
                onChange={handleSetFile}
                accept=".xlsx"
                name="documento"
                id="files"
                type="file"
                className="btn btn-default"
                style={{ marginBottom: 20, width: "100%", marginTop: 20 }}
              />
              <button
                onClick={handleUpload}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(CargaMasiva);
